import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Pins every request to `/backend/v2/scheduling/...` to the user's currently
 * selected store by appending `?store=<id>`.
 *
 * Multi-store users have several Stores linked through UserAccount, so the
 * backend can't know which one the user is viewing.  The StoreService writes
 * the selected store id to localStorage under `currentStore`; we read it
 * here so the same value flows to scheduling endpoints.
 */
@Injectable()
export class SchedulingStoreInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.includes('/backend/v2/scheduling/')) {
      return next.handle(request);
    }
    // Don't clobber an explicit ?store= that callers already set.
    if (request.params.has('store') || request.params.has('store_id')) {
      return next.handle(request);
    }
    const storeId = this._currentStoreId();
    if (!storeId) {
      return next.handle(request);
    }
    return next.handle(
      request.clone({ params: request.params.set('store', storeId) }),
    );
  }

  private _currentStoreId(): string | null {
    try {
      const raw = localStorage.getItem('currentStore');
      if (!raw) return null;
      // Stored as a bare id string by StoreService.setStore.
      return raw.replace(/"/g, '').trim() || null;
    } catch {
      return null;
    }
  }
}
